import Client from './client';

export default class GiftCardPrograms extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/gift_cards`, options);
  }

  post(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/gift_cards`, {
      ...options,
       method: 'POST',
    });
  }

  deleteById(organization, number, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/gift_cards/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
